import { Link } from "react-router-dom";

// Shared footer for the redesigned sidebar-shell pages (Home, Music, Charts,
// etc.) — rendered by Layout.tsx as the last element in each page's
// scrollable content, right above the fixed bottom nav on mobile/tablet.
// Plain block flow (no mt-auto/flex pinning): Layout's <main> is a flex-grow
// row child with flex-basis 0, so stretching it with a flex column to pin
// this via mt-auto made its rendered height stop tracking its own
// (now-taller) content — the footer visually overflowed past that height
// without actually growing the document's scrollable area, so part of it
// was unreachable by scrolling. Staying in normal flow avoids that; on
// pages shorter than the viewport the footer just follows the content
// instead of sitting flush at the very bottom, which is a fine trade-off.
export function FooterBand() {
  return (
    <div
      data-app-footer
      className="bg-[#0E0C24] px-5 py-6 sm:px-10 lg:px-14 flex flex-col gap-5"
    >
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex flex-wrap justify-center gap-5 text-[13px]">
          <Link to="/songs" className="text-[#9A96C4]">
            Music
          </Link>
          <Link to="/charts" className="text-[#9A96C4]">
            Charts
          </Link>
          <Link to="/sponsors" className="text-[#9A96C4]">
            Sponsors
          </Link>
          <Link to="/plans" className="text-[#9A96C4]">
            Plans
          </Link>
        </div>
        <span className="font-jetbrains text-xs text-[#9A96C4]">
          PayStreem, Nigeria
        </span>
      </div>
      <div className="h-px bg-white/10" />
      <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
        <span className="text-center text-[12px] text-[#6E6B8A] sm:text-left">
          &copy; {new Date().getFullYear()} PayStreem. All rights reserved.
          Developed by Giant Beats Technologies
        </span>
        <div className="flex flex-wrap justify-center gap-4 text-[12px] sm:justify-end">
          <Link to="/terms" className="text-[#6E6B8A] hover:text-[#9A96C4]">
            Terms
          </Link>
          <Link to="/privacy" className="text-[#6E6B8A] hover:text-[#9A96C4]">
            Privacy
          </Link>
          <Link to="/copyright" className="text-[#6E6B8A] hover:text-[#9A96C4]">
            Copyright
          </Link>
          <Link
            to="/aml-policy"
            className="text-[#6E6B8A] hover:text-[#9A96C4]"
          >
            AML Policy
          </Link>
        </div>
      </div>
    </div>
  );
}
